import { css } from '@emotion/react';

import COLORS from 'shared/styles/colors';
import { mediaquery } from 'shared/styles/styleFunctions';
import theme from 'shared/styles/themes';

export default css({
  '.single-revision': {
    '&__header': {
      fontWeight: 600,
      fontSize: '16px',
      fontStyle: 'normal',
      lineHeight: 'normal',
    },
    '&__header-group': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    '&__sub-header': {
      fontWeight: 400,
      marginBottom: theme.space[6],
    },
    '&__status': {
      fontSize: theme.fontSizes[0],
      borderRadius: '2px',
      backgroundColor: COLORS.RED200,
      color: COLORS.BLACK,
      padding: `0 ${theme.space[2]}`,
    },
    '&__status--done': {
      backgroundColor: COLORS.GREEN300,
    },
    '&__btn': {
      '& .edit-button__btn-icon, & .delete-button__btn-icon': {
        fontSize: '18px',
        width: '16px',
        height: '16px',
        // Apply transform on mobile (below md breakpoint)
        transform: 'translateY(-4px)',
      },
      [mediaquery.md]: {
        '& .edit-button__btn-icon, & .delete-button__btn-icon': {
          // Reset transform on larger screens
          transform: 'translateY(-1px)',
        },
      },
    },
    '&__btn:first-of-type': {
      margin: `0 ${theme.space[4]}`,
    },
    '&__action-wrapper': {
      position: 'relative',
      top: 0,
      right: 0,
      fontWeight: 400,
      fontSize: '11px',
      justifyContent: 'flex-end',
      alignItems: 'center',
      background: `linear-gradient(to left, ${COLORS.WHITE}, 95%, transparent);`,
    },
  },
});
